import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { isSupportedSchemaFieldType } from '@core-engine/schema/type-mappers/validation/is-supported-schema-field-type.js'
import { unsupportedSchemaFieldTypeMessage } from '@core-engine/schema/type-mappers/validation/unsupported-schema-field-type-message.js'
import { collectInvalidSchemaSlotFieldTypeErrors } from './collect-invalid-schema-slot-field-type-errors.js'

export function collectInvalidSchemaFieldTypeErrors(fields: SchemaField[], errors: string[]): void {
  for (const field of fields) {
    if (!isSupportedSchemaFieldType(field)) {
      errors.push(unsupportedSchemaFieldTypeMessage(field))
    }

    if (field.fields) {
      collectInvalidSchemaFieldTypeErrors(field.fields, errors)
    }
    if (field.items) {
      collectInvalidSchemaFieldTypeErrors([field.items as SchemaField], errors)
    }
    if (field.tabs) {
      for (const tab of field.tabs) {
        collectInvalidSchemaFieldTypeErrors(tab.fields || [], errors)
        collectInvalidSchemaSlotFieldTypeErrors(tab.slot, errors)
      }
    }
  }
}
